export default
{
    props:
    {
        hiddenHeight: { type: Number, default: 0 },
        content: { type: String, default: null },
        diff: { type: Number, default: 0 },
    },

    watch:
    {
        hiddenHeight: 'onResize'
    },

    data()
    {
        return {
            isExpanded: false,
            hasBtn: true
        }
    },

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
    },

    mounted()
    {
        this.$top = this.$el.querySelector('.js-top')
        this.$bottom = this.$el.querySelector('.js-bottom')

        this.onResize()
    },

    methods:
    {
        onResize()
        {
            this._bottomHeight = this.$bottom.offsetHeight

            if(this._bottomHeight < 200)
            {
                this.hasBtn = false
                return
            }

            this.$top.style.height = 200 + 'px'

            if(this.isExpanded)
            {
                this.onReadMore()
            }
        },

        onReadMore()
        {
            this.isExpanded = !this.isExpanded
            this.$el.classList.toggle('is-expanded')

            if(this.isExpanded)
            {
                this.$top.style.height = this._bottomHeight + 'px'
            }
            else
            {
                this.$top.style.height = 200 + 'px'
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-read-more/script.js